import { handleActions } from "redux-actions";
import { SCOPE } from "constants/action-types";

export interface IState {
    error: any;
    fetching: boolean;
    show404: boolean;
}

const initialState: any = {
    error: undefined,
    fetching: true,
    show404: false,
};

export const brandedLogin = handleActions(
    {
        [SCOPE.BRANDED_LOGIN.START]: (state: IState): IState => {
            return {
                ...state,
                fetching: true,
            };
        },
        [SCOPE.BRANDED_LOGIN.COMPLETED]: (state: IState, { error, payload }: any): IState => {
            if (error) {
                const brandIsInactive = payload && payload.status === 308;
                return {
                    ...state,
                    error: payload,
                    fetching: false,
                    show404: brandIsInactive ? false : true,
                };
            }
            return {
                ...state,
                fetching: false,
                show404: false,
            };
        },
        [SCOPE.BRANDED_LOGIN.SPINNER]: (state: IState, { payload }: any): IState => {
            return {
                ...state,
                fetching: payload,
            };
        },
    },
    initialState
);
